export const USERROLE = {
  SuperAdmin: 'super_admin',
  /**
   * Account Admin — DB role_name remains `company_admin`.
   * Prefer AccountAdmin in new code; CompanyAdmin kept as alias.
   */
  AccountAdmin: 'company_admin',
  CompanyAdmin: 'company_admin',
  AccountManager: 'account_manager',
  AccountViewer: 'account_viewer',
};

/** Admin-equivalent (tenant admin). */
export const ROLES_ACCOUNT_ADMIN = [USERROLE.SuperAdmin, USERROLE.AccountAdmin];

/** Manager write access (includes admins). */
export const ROLES_ACCOUNT_MANAGER = [
  USERROLE.SuperAdmin,
  USERROLE.AccountAdmin,
  USERROLE.AccountManager,
];

/** Any authenticated account role including viewers. */
export const ROLES_ACCOUNT_ANY = [
  USERROLE.SuperAdmin,
  USERROLE.AccountAdmin,
  USERROLE.AccountManager,
  USERROLE.AccountViewer,
];

export const awsRegion = [
  'us-east-2',
  'us-east-1',
  'us-west-1',
  'us-west-2',
  'af-south-1',
  'ap-east-1',
  'ap-south-2',
  'ap-southeast-3',
  'ap-southeast-4',
  'ap-south-1',
  'ap-northeast-3',
  'ap-northeast-2',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-northeast-1',
  'ca-central-1',
  'ca-west-1',
  'eu-central-1',
  'eu-west-1',
  'eu-west-2',
  'eu-south-1',
  'eu-west-3',
  'eu-south-2',
  'eu-north-1',
  'eu-central-2',
  'il-central-1',
  'me-south-1',
  'me-central-1',
  'sa-east-1',
  'us-gov-east-1',
  'us-gov-west-1',
];

export const DAGHeaders = [
  {
    header: 'Name',
    key: 'name',
  },
  {
    header: 'Description',
    key: 'description',
  },

  {
    header: 'Created',
    key: 'created',
  },
  {
    header: 'Modified',
    key: 'modified',
  },
  {
    header: 'CreatedBy',
    key: 'createdBy',
  },
];

export const notificationStatus = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Success',
    value: 'Success',
  },
  {
    label: 'Error',
    value: 'Error',
  },
];
export const notificationCategories = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Data Ingestion',
    value: 'Ingestion',
  },
  {
    label: 'Connector Configuration',
    value: 'Connector',
  },
  {
    label: 'Ingestion Configuration',
    value: 'Config',
  },
];

export const notificationData = [
  {
    subject: 'Configuration message',
    body:
      'Filename_121 has been updated,Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
    created_at: Date.now(),
    read_info: {
      is_read: false,
    },
    type: 'warn',
  },
  {
    subject: 'New configuration creation',
    body:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elLorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
    created_at: '2024-11-21T05:49:12.454563Z',
    read_info: {
      is_read: true,
    },
    type: 'warn',
  },
  {
    subject: 'Configuration message',
    body:
      'Filename_121 has been updated,Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
    created_at: '2024-11-21T04:49:12.454563Z',
    read_info: {
      is_read: false,
    },
    type: 'primary',
  },
  {
    subject: 'Configuration message',
    body:
      'Filename_121 has been updated,Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
    created_at: '2024-11-21T03:49:12.454563Z',
    read_info: {
      is_read: false,
    },
    type: 'warn',
  },
  {
    subject: 'Configuration message',
    body:
      'Filename_121 has been updated,Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
    created_at: '2024-11-20T06:49:12.454563Z',
    read_info: {
      is_read: false,
    },
    type: 'warn',
  },
];
export const getFormattedDate = date => {
  const month = (date?.getMonth() + 1).toString().padStart(2, '0');
  const day = date
    ?.getDate()
    .toString()
    .padStart(2, '0');
  const year = date?.getFullYear();
  return `${year}/${month}/${day}`;
};

export const parseDateRange = date_range => {
  const [startDateStr, endDateStr] = date_range.split('-');
  const parseDate = dateStr => {
    const [year, month, day] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  };
  return {
    startDate: parseDate(startDateStr),
    endDate: parseDate(endDateStr),
  };
};

export const DEBOUNCE_TIME = 2000;

export const FIELD_NAME_REGEX = /^(?!.*DP_A360_)[a-zA-Z][a-zA-Z0-9_]{0,114}$/i;

export const rejectReasons = {
  LEN: 'Length exceeded',
  NULLABLE: 'Null values in the mandatory field',
  CREGEX: 'Date format not matching expected format',
  DUPE: 'Duplicate records rejected based on deduplication key',
};

export const rejectTableHeaders = [
  {
    header: 'No.',
    key: 'id',
    width: '125px',
  },
  {
    header: 'Field Name',
    key: 'field_name',
  },
  {
    header: 'Description',
    key: 'description',
  },
  {
    header: 'No. Of Occurences',
    key: 'occurences',
    width: '415px',
  },
];

export const validationStatus = {
  Successful: 'SUCCESS',
  'In Progress': 'IN_PROGRESS',
  Error: 'ERROR',
  Queued: 'QUEUED',
};

export const platform = {
  2: 'AWS S3',
  3: 'GCS',
};

export const cloudEnvironment = {
  FILESYSTEM: 1,
  S3: 2,
  GCS: 3,
};
